var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0L20.5923 11.0556C20.7261 11.4676 21.11 11.7466 21.5433 11.7466H33.168L23.7634 18.5795C23.4129 18.8341 23.2662 19.2854 23.4001 19.6975L26.9923 30.7533L17.5878 23.9205C17.2373 23.6658 16.7627 23.6658 16.4122 23.9205L7.00771 30.7533L10.5998 19.6975C10.7337 19.2855 10.5871 18.8341 10.2366 18.5795L0.832031 11.7466H12.4567C12.89 11.7466 13.2739 11.4677 13.4077 11.0557L17 0ZM17 6.47203L15.3099 11.6736C14.9083 12.9098 13.7564 13.7466 12.4567 13.7466H6.98741L11.4122 16.9614C12.4637 17.7254 12.9036 19.0795 12.5019 20.3156L10.8119 25.5172L15.2366 22.3024C16.2881 21.5385 17.7119 21.5385 18.7634 22.3024L23.1881 25.5172L21.4981 20.3156C21.0964 19.0795 21.5363 17.7254 22.5878 16.9614L27.0126 13.7466H21.5433C20.2436 13.7466 19.0917 12.9098 18.6901 11.6736L17 6.47203Z",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/IconStar.800e12c8bec10a944324244b563dde93.svg";
export { ForwardRef as ReactComponent };